import * as React from 'react';
import type { SVGProps } from 'react';
import type { IconProps, ForwardedIconComponent } from './types';
const PlayerNextOutlined = (React.forwardRef<SVGSVGElement, SVGProps<SVGSVGElement> & IconProps>(function PlayerNextOutlined({
  title,
  titleId,
  size = '1em',
  ...props
}, ref) {
  return <svg width={size} height={size} viewBox="0 0 24 24" fill="none" ref={ref} aria-labelledby={titleId} {...props}>
        {title ? <title id={titleId}>{title}</title> : null}
        <path d="M18 2v8.24L4 2v20l14-8.24V22h2V2h-2Zm-1.01 10.04L6 18.5V5.49l10.99 6.46.07.04-.07.04v.01Z" fill="currentColor" />
      </svg>;
}) as ForwardedIconComponent);
export default PlayerNextOutlined;